import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function FeatureGate({ feature, children }: { feature: string; children: React.ReactNode }) {
  const { user } = useAuth();
  if (!user?.features?.includes(feature)) return <section role="status" className="max-w-lg py-8 space-y-4">
    <h1 className="text-2xl font-semibold">Access needed</h1>
    <p className="text-muted-foreground">Your account does not have access to this section. Ask your workspace administrator to review your permissions.</p>
    <Link to="/app" className="inline-flex items-center min-h-11 px-4 rounded-lg border border-border">Return to the app</Link>
  </section>;
  return <>{children}</>;
}
